var bookshelf = require("../index-extended");
require("./BuildingOwnerVotingRight");
require("./Building");

module.exports = bookshelf.model("VotingCategory", {
  entityName: "VotingCategory",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "voting_category",
  building_owner_voting_rights() {
    return this.hasMany("BuildingOwnerVotingRight", "voting_category_id");
  },
  building() {
    return this.belongsTo("Building");
  },

  format(attrs) {
    delete attrs["$id"];
    delete attrs["building_owner_voting_rights"];

    return attrs;
  },
});
